import { render, staticRenderFns } from "./SetZone.vue?vue&type=template&id=4c3a68f7&lang=pug"
import script from "./SetZone.vue?vue&type=script&lang=js"
export * from "./SetZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports